import ClipLoader from 'react-spinners/ClipLoader';

const Spinner = ({ color = '#000', size = 14 }) => (
  <ClipLoader color={color} loading={true} size={size} />
);

export default Spinner;
